import {
  IAssembleiaConsultaByCpfCnpj,
  IAssembleiaAssociadoEvento,
  IAssembleiaAssociadoPauta,
  IAssembleiaContasAssociado,
  IAssembleiaAssociadoRespostaPauta,
  IEventosPorAssociado,
} from './AssembleiasAssociadoReducer';
import { IWSAssembleia } from './WSAssembleiasReducer';
import { ListaPerguntas } from 'api/DuvidasFrequentes';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS';
export const ASSEMBLEIAS_ASSOCIADO_FLAG_SEM_EMANCIPADO =
  'ASSEMBLEIAS_ASSOCIADO_FLAG_SEM_EMANCIPADO';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_CLEARED_EVENT =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_CLEARED_EVENT';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS';
export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS';

export const ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH =
  'ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH';

export const ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA =
  'ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA';

export const ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA =
  'ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA';

export const ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION =
  'ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION';

export const ASSEMBLEIAS_ASSOCIADO_FLAG_PRESENCA_NAO_ONLINE =
  'ASSEMBLEIAS_ASSOCIADO_FLAG_PRESENCA_NAO_ONLINE';

export interface IAssembleiasAssociadoRegistraPresenca {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_PRESENCA;
  payload: {
    cpfCnpj: string;
    aceite: boolean;
    idsConvocados: number[];
    assembleiaId: number;
  };
}

export interface IAssembleiasAssociadoRegistraVoto {
  payload: any;
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REGISTRA_VOTO;
}

export interface IAssembleiasAssociadoLoadingPautas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_PAUTAS;
  payload: boolean;
}

export interface IAssembleiasAssociadoLoadPautas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_PAUTAS;
  assembleiaId: number;
  payload: IAssembleiaAssociadoPauta[];
}

export interface IAssembleiasAssociadoLoadingContas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_CONTAS;
  payload: boolean;
}

export interface IAssembleiasAssociadoLoadContas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_CONTAS;
  payload: IAssembleiaContasAssociado;
}

export interface IAssembleiasAssociadoLoadFlagMenorSemEmancipado {
  type: typeof ASSEMBLEIAS_ASSOCIADO_FLAG_SEM_EMANCIPADO;
  payload: any;
}

export interface IAssembleiasAssociadoLoadFlagPresencaNaoOnline {
  type: typeof ASSEMBLEIAS_ASSOCIADO_FLAG_PRESENCA_NAO_ONLINE;
  payload: any;
}

export interface IAssembleiasAssociadoLoadingAll {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_ALL;
  payload: boolean;
}

export interface IAssembleiasAssociadoLoadAll {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_ALL;
  payload: IEventosPorAssociado[];
}

export interface IAssembleiaAssociadoDeleteCurrentEvent {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_DELETE_CURRENT_EVENT;
  payload: undefined;
}

export interface IAssembleiaAssociadoLoadingEvent {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_EVENT;
  payload: boolean;
}

export interface IAssembleiaAssociadoClearedEvent {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_CLEARED_EVENT;
}

export interface IAssembleiaAssociadoLoadEvent {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_EVENT;
  payload: IAssembleiaAssociadoEvento;
}

export interface IAssembleiaAssociadoRequestFile {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REQUEST_FILE;
  payload: number[];
}

export interface IAssembleiaAssociadoDownloadFileSuccess {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_DOWNLOAD_FILE_SUCCESS;
  payload: number[];
}

export interface IAssembleiaAssociadoLoadingByCpfCnpj {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_BY_CPF_CNPJ;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadByCpfCnpj {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_BY_CPF_CNPJ;
  payload: IAssembleiaConsultaByCpfCnpj[];
}

export interface IAssembleiaAssociadoLoadingDuvidas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOADING_DUVIDAS;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadDuvidas {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_LOAD_DUVIDAS;
  payload: ListaPerguntas;
}

export interface IAssembleiaAssociadoRefresh {
  type: typeof ASSEMBLEIAS_ASSOCIADO_ACTIONS_REFRESH;
  payload: IWSAssembleia;
}

export interface IAssembleiaAssociadoLoadingPautaResposta {
  type: typeof ASSEMBLEIAS_ASSOCIADO_LOADING_RESPOSTA_PAUTA;
  payload: boolean;
}

export interface IAssembleiaAssociadoLoadPautaResposta {
  type: typeof ASSEMBLEIAS_ASSOCIADO_LOAD_RESPOSTA_PAUTA;
  payload: IAssembleiaAssociadoRespostaPauta;
}

export interface IAssembleiaAsociadoUpdateVotePermission {
  type: typeof ASSEMBLEIAS_ASSOCIADO_UPDATE_VOTE_PERMISSION;
  payload: boolean;
}

export type AssembleiasAssociadoActionTypes =
  | IAssembleiasAssociadoRegistraPresenca
  | IAssembleiasAssociadoRegistraVoto
  | IAssembleiasAssociadoLoadingPautas
  | IAssembleiasAssociadoLoadPautas
  | IAssembleiasAssociadoLoadingContas
  | IAssembleiasAssociadoLoadContas
  | IAssembleiasAssociadoLoadingAll
  | IAssembleiasAssociadoLoadAll
  | IAssembleiaAssociadoDeleteCurrentEvent
  | IAssembleiaAssociadoLoadingEvent
  | IAssembleiaAssociadoClearedEvent
  | IAssembleiaAssociadoLoadEvent
  | IAssembleiaAssociadoClearedEvent
  | IAssembleiaAssociadoRequestFile
  | IAssembleiaAssociadoDownloadFileSuccess
  | IAssembleiaAssociadoLoadingByCpfCnpj
  | IAssembleiaAssociadoLoadByCpfCnpj
  | IAssembleiaAssociadoLoadingDuvidas
  | IAssembleiaAssociadoLoadDuvidas
  | IAssembleiaAssociadoRefresh
  | IAssembleiaAssociadoLoadingPautaResposta
  | IAssembleiaAssociadoLoadPautaResposta
  | IAssembleiaAsociadoUpdateVotePermission
  | IAssembleiasAssociadoLoadFlagMenorSemEmancipado
  | IAssembleiasAssociadoLoadFlagPresencaNaoOnline;
